'use strict';

angular.module('studies')
    .component('studyUpdateForm', {
        templateUrl: 'js/modules/studies/components/update-form/template.html',
        controller: 'StudyUpdateFormController',
        require: {
            study: '^^studyMain',
        },
        bindings: {
            'onSubmit': '&',
        },
    });
